import SlimSelect from 'slim-select';

const selectEls = document.querySelectorAll('select.slim-select');

if (selectEls.length > 0) {
    selectEls.forEach(function (select) {
        new SlimSelect({
            select,
            showSearch: false
        });
    });
}

function headerActive() {
    const header = document.querySelector('.js-header');
    if (window.scrollY > 0) {
        header.classList.add("sticky");
    } else {
        header.classList.remove("sticky");
    }
}

$(window).load(headerActive);
$(window).scroll(headerActive);

document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth >= 1023) return;

    document.querySelector('.js-header > .page-header__container > .main-nav').remove();

    const megaMenu = document.querySelector("#mega-menu-menu-1");
    let currentLevel = 0;
    let previousSubMenus = [];

    const subMenuContainer = document.createElement("div");
    subMenuContainer.classList.add("submenu-container");

    const updateSubmenuContainerClass = () => {
    const openedMenu = subMenuContainer.querySelector(".mega-sub-menu.open");

        subMenuContainer.classList.toggle(
            "active-long",
            openedMenu?.id === "submenu-l3-1-1"
        );
    };

    // Shared sliding logic, reused by every level of the mobile menu
    // (level 1 -> 2 via the .mega-indicator, level 2 -> 3 via the
    // .js-toggle-sub-link category links). Opening a panel pushes it onto the
    // stack and shifts the whole mega-menu one level left; going back pops it
    // and shifts one level right.
    const openPanel = (targetId) => {
        if (!targetId) return;

        const targetSubMenu = document.getElementById(targetId);
        if (!targetSubMenu) return;

        const allSubMenus = subMenuContainer.querySelectorAll(".mega-sub-menu");
        allSubMenus.forEach(sm => sm.classList.remove("open"));

        targetSubMenu.classList.add("open", "animate-in");
        updateSubmenuContainerClass();

        setTimeout(() => {
            targetSubMenu.classList.remove("animate-in");
        }, 300);

        if (previousSubMenus.length > 0) {
            const prevSubMenu = previousSubMenus[previousSubMenus.length - 1];
            prevSubMenu.classList.add("closed");
        }

        previousSubMenus.push(targetSubMenu);

        currentLevel++;
        megaMenu.classList.add(`shift-level-${currentLevel}`);
    };

    const goBack = (currentSubMenu) => {
        if (!currentSubMenu) return;

        currentSubMenu.classList.remove("open", "animate-in");

        if (previousSubMenus.length > 1) {
            const prevSubMenu = previousSubMenus[previousSubMenus.length - 2];
            if (prevSubMenu) {
                prevSubMenu.classList.remove("closed");
                prevSubMenu.classList.add("open");
            }
        }

        if (previousSubMenus.length > 0) {
            previousSubMenus.pop();
        }

        if (currentLevel > 0) {
            megaMenu.classList.remove(`shift-level-${currentLevel}`);
            currentLevel--;
            megaMenu.classList.add(`shift-level-${currentLevel}`);
        }

        setTimeout(updateSubmenuContainerClass, 0);
    };

    const assignUniqueIdentifiers = () => {
        const menuItems = megaMenu.querySelectorAll(".mega-menu-item");
        menuItems.forEach((item, index) => {
            const link = item.querySelector(".mega-menu-link");
            const subMenu = item.querySelector(".mega-sub-menu");

            const uniqueId = `submenu-${index + 1}`;
            if (link) {
                link.setAttribute("data-target", uniqueId);
            }

            if (subMenu) {
                subMenu.setAttribute("id", uniqueId);
            }
        });
    };

    assignUniqueIdentifiers();

    const addBackButton = () => {
        const subMenus = megaMenu.querySelectorAll(".mega-sub-menu");
        subMenus.forEach(subMenu => {
            const backButton = document.createElement("button");
            backButton.classList.add("mega-back-button");
            backButton.textContent = "Back to main menu";

            subMenu.insertBefore(backButton, subMenu.firstChild);

            backButton.addEventListener("click", (e) => {
                e.preventDefault();
                const currentSubMenu = e.target.closest(".mega-sub-menu");
                goBack(currentSubMenu);
            });
        });
    };

    addBackButton();

    const addTopLinkToSubMenus = () => {
        const menuItems = megaMenu.querySelectorAll(".mega-menu-item");

        menuItems.forEach(menuItem => {
            const link = menuItem.querySelector(".mega-menu-link");
            const subMenu = menuItem.querySelector(".mega-sub-menu");

            if (link && subMenu) {
                const topLinkItem = document.createElement("li");
                topLinkItem.classList.add("mega-menu-item", "mega-menu-item-type-widget", "widget_custom_html");

                const customHTMLDiv = document.createElement("div");
                customHTMLDiv.classList.add("textwidget", "custom-html-widget");

                const menuItemsTitleDiv = document.createElement("div");
                menuItemsTitleDiv.classList.add("mega-menu-items-title");

                const anchor = document.createElement("a");
                anchor.classList.add("btn-with-arrow-45", "btn-with-arrow-45--light");
                anchor.href = link.href;
                anchor.target = "_self";

                const mainTitleSpan = document.createElement("span");
                mainTitleSpan.classList.add("menu-row-main-title", "text");
                mainTitleSpan.textContent = link.textContent;

                const arrowSpan = document.createElement("span");
                arrowSpan.classList.add("arrow");

                const arrowDefaultImg = document.createElement("img");
                arrowDefaultImg.classList.add("default");
                arrowDefaultImg.src = "/wp-content/themes/f5-studio/src/assets/icons/arrow-45-gradient-light.svg";
                arrowDefaultImg.alt = "arrow";

                const arrowGradientImg = document.createElement("img");
                arrowGradientImg.classList.add("gradient");
                arrowGradientImg.src = "/wp-content/themes/f5-studio/src/assets/icons/arrow-45-gradient.svg";
                arrowGradientImg.alt = "arrow";

                arrowSpan.appendChild(arrowDefaultImg);
                arrowSpan.appendChild(arrowGradientImg);

                anchor.appendChild(mainTitleSpan);
                anchor.appendChild(arrowSpan);

                menuItemsTitleDiv.appendChild(anchor);
                customHTMLDiv.appendChild(menuItemsTitleDiv);
                topLinkItem.appendChild(customHTMLDiv);

                subMenu.insertBefore(topLinkItem, subMenu.firstChild);
            }
        });
    };

    addTopLinkToSubMenus();

    const indicators = megaMenu.querySelectorAll(".mega-indicator");
    indicators.forEach(indicator => {
        indicator.addEventListener("click", (event) => {
            event.preventDefault();
            const menuItem = event.target.closest(".mega-menu-item");
            if (!menuItem) return;

            const link = menuItem.querySelector(".mega-menu-link");
            const targetId = link ? link.getAttribute("data-target") : null;
            openPanel(targetId);
        });
    });

    // Build the third-level panels for the mobile menu.
    //
    // On desktop, the "Services" panel shows a list of categories
    // (.js-toggle-sub-link: Web Development, Design, Outsourcing, ...) and,
    // on hover, swaps in that category's detail column of page links. On
    // mobile those detail columns are hidden, so there is nothing to drill
    // into. Here we lift each category's page links into its own
    // .mega-sub-menu panel and point the category link's data-target at it,
    // so tapping a category slides to level 3 exactly like level 1 -> 2.
    //
    // IMPORTANT: this must run BEFORE processSubmenus(), which flattens every
    // .mega-sub-menu out of its nested position and would otherwise break the
    // positional category <-> row relationship we rely on below.
    const buildThirdLevelPanels = () => {
        // Each top-level item that owns a grid mega menu (e.g. Services).
        const megaRowGroups = megaMenu.querySelectorAll(".mega-menu-megamenu");

        megaRowGroups.forEach((group, groupIndex) => {
            const toggleLinks = group.querySelectorAll(".js-toggle-sub-link");
            const serviceRows = group.querySelectorAll(".mega-services");

            if (!toggleLinks.length || !serviceRows.length) return;

            toggleLinks.forEach((toggleItem, index) => {
                const categoryLink = toggleItem.querySelector("a.mega-menu-link");
                const row = serviceRows[index];
                if (!categoryLink || !row) return;

                // The detail column that holds this category's page links.
                // Among the .mega-menu-columns-2-of-9 columns, pick the first
                // whose inner list actually contains page links (post_type or
                // custom items) - this skips the "Related reads" / "Continue
                // Exploring" columns, which also use 2-of-9 + .mega-sub-menu.
                const detailColumns = row.querySelectorAll(".mega-menu-column.mega-menu-columns-2-of-9");
                let sourceList = null;
                detailColumns.forEach(col => {
                    if (sourceList) return;
                    const innerList = col.querySelector(".mega-sub-menu");
                    if (!innerList) return;
                    const hasPageLinks = innerList.querySelector(
                        ":scope > li.mega-menu-item-type-post_type, :scope > li.mega-menu-item-type-custom"
                    );
                    if (hasPageLinks) sourceList = innerList;
                });

                if (!sourceList) return;

                // Create the level-3 panel as a .mega-sub-menu so it inherits
                // all the existing sliding-panel styles.
                const panel = document.createElement("ul");
                panel.classList.add("mega-sub-menu", "submenu-l-2", "js-level-3-panel");
                panel.setAttribute("role", "presentation");

                const panelId = `submenu-l3-${groupIndex + 1}-${index + 1}`;
                panel.setAttribute("id", panelId);

                // Heading row: the category title, styled like the existing
                // level-2 top link (re-using the markup the plugin already
                // outputs for the "Our Services" style heading).
                const headingItem = document.createElement("li");
                headingItem.classList.add(
                    "mega-menu-item",
                    "mega-menu-item-type-widget",
                    "widget_custom_html"
                );

                const headingHtml = document.createElement("div");
                headingHtml.classList.add("textwidget", "custom-html-widget");

                const headingTitle = document.createElement("div");
                headingTitle.classList.add("mega-menu-items-title");

                const headingAnchor = document.createElement("a");
                headingAnchor.classList.add("btn-with-arrow-45", "btn-with-arrow-45--light");
                headingAnchor.href = categoryLink.getAttribute("href") || "#";
                headingAnchor.target = "_self";

                const headingText = document.createElement("span");
                headingText.classList.add("menu-row-main-title", "text");
                headingText.textContent = categoryLink.textContent.trim();

                const headingArrow = document.createElement("span");
                headingArrow.classList.add("arrow");

                const headingArrowDefault = document.createElement("img");
                headingArrowDefault.classList.add("default");
                headingArrowDefault.src = "/wp-content/themes/f5-studio/src/assets/icons/arrow-45-gradient-light.svg";
                headingArrowDefault.alt = "arrow";

                const headingArrowGradient = document.createElement("img");
                headingArrowGradient.classList.add("gradient");
                headingArrowGradient.src = "/wp-content/themes/f5-studio/src/assets/icons/arrow-45-gradient.svg";
                headingArrowGradient.alt = "arrow";

                headingArrow.appendChild(headingArrowDefault);
                headingArrow.appendChild(headingArrowGradient);
                headingAnchor.appendChild(headingText);
                headingAnchor.appendChild(headingArrow);
                headingTitle.appendChild(headingAnchor);
                headingHtml.appendChild(headingTitle);
                headingItem.appendChild(headingHtml);
                panel.appendChild(headingItem);

                // Back button (level 3 -> level 2), matching the ones the
                // existing addBackButton() adds to plugin-generated panels.
                const backButton = document.createElement("button");
                backButton.classList.add("mega-back-button");
                backButton.textContent = "Back";
                backButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    goBack(e.target.closest(".mega-sub-menu"));
                });
                panel.insertBefore(backButton, panel.firstChild);

                // Copy the page links from the detail column. Only the actual
                // page links are relevant on mobile; the desktop-only "Our X"
                // title button is skipped.
                const pageItems = sourceList.querySelectorAll(
                    ":scope > li.mega-menu-item-type-post_type, :scope > li.mega-menu-item-type-custom"
                );

                pageItems.forEach(pageItem => {
                    const clone = pageItem.cloneNode(true);
                    // Strip nested submenus / desktop targets; these are flat links.
                    clone.querySelectorAll(".mega-sub-menu").forEach(sm => sm.remove());
                    const cloneLink = clone.querySelector("a.mega-menu-link");
                    if (cloneLink) cloneLink.removeAttribute("data-target");
                    panel.appendChild(clone);
                });

                // Append into the shared container and wire the category link.
                subMenuContainer.appendChild(panel);
                categoryLink.setAttribute("data-target", panelId);

                categoryLink.addEventListener("click", (event) => {
                    // On desktop these links navigate / are hover-driven, so
                    // only intercept for the mobile sliding behaviour.
                    if (window.innerWidth >= 1024) return;
                    event.preventDefault();
                    openPanel(panelId);
                });
            });
        });
    };

    buildThirdLevelPanels();

    const processSubmenus = () => {
        const allMenus = megaMenu.querySelectorAll(".mega-menu-item");

        allMenus.forEach((menuItem) => {
            let level = 1;
            let currentItem = menuItem;

            while (currentItem.closest(".mega-sub-menu")) {
                level++;
                currentItem = currentItem.closest(".mega-sub-menu").parentElement;
            }

            menuItem.setAttribute("data-level", level);
            menuItem.classList.add(`submenu-l-${level}`);

            const subMenu = menuItem.querySelector(".mega-sub-menu");
            if (subMenu) {
                subMenu.classList.add(`submenu-l-${level}`);
                subMenuContainer.appendChild(subMenu);
            }
        });
    };

    processSubmenus();
    megaMenu.parentNode.appendChild(subMenuContainer);
});

document.addEventListener("DOMContentLoaded", function () {

    const searchElement = document.querySelector('.ss-search.ss-hide');

    if (searchElement) {
        searchElement.remove();
    }

    const $body = document.querySelector('body'),
        $menuBtn = document.querySelector('.js-menu-btn'),
        $mobileMenu = document.querySelector('.js-mobile-menu'),
        $mobileOverlay = document.querySelector('.js-mob-overlay'),
        $header = document.querySelector('.page-header');

    $menuBtn.addEventListener('click', () => {
        $body.classList.toggle('ov-hidden');
        $menuBtn.classList.toggle('open');
        $mobileMenu.classList.toggle('open');
        $mobileOverlay.classList.toggle('open');
        setTimeout(() => {
            $header.classList.toggle('open-mob-menu');
        }, 150);
    });

    const toggleLinks = document.querySelectorAll(".js-toggle-sub-link"),
        megaServices = document.querySelectorAll(".mega-services");

    if (toggleLinks.length > 0 && megaServices.length > 0) {
        const firstToggleLink = toggleLinks[0].querySelector("a");
        if (firstToggleLink) {
            firstToggleLink.classList.add("active");
        }

        megaServices[0].classList.add("active");

        toggleLinks.forEach((toggleLink, index) => {
            const link = toggleLink.querySelector("a");

            if (link) {
                link.addEventListener("click", function (event) {
                    if (window.innerWidth >= 1024) {
                        event.preventDefault();
                    }
                });
                link.addEventListener("mouseenter", function (event) {
                    if (window.innerWidth >= 1024) {
                        event.preventDefault();

                        toggleLinks.forEach(tl => {
                            const a = tl.querySelector("a");
                            if (a) a.classList.remove("active");
                        });
                        megaServices.forEach(ms => ms.classList.remove("active"));

                        link.classList.add("active");
                        if (megaServices[index]) {
                            megaServices[index].classList.add("active");
                        }
                    }
                });
            }
        });

        let maxHeight = 0;
        megaServices.forEach(ms => {
            const height = ms.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        megaServices.forEach(ms => {
            ms.style.height = `${maxHeight}px`;
        });

        megaServices.forEach((ms, index) => {
            const relatedToggleLink = toggleLinks[index]?.querySelector("a");
            if (relatedToggleLink) {
                const linkText = relatedToggleLink.textContent.trim();
                const linkHref = relatedToggleLink.getAttribute("href");
                const megaMenuColumn = ms.querySelector(".mega-menu-column.mega-menu-columns-2-of-9");

                if (megaMenuColumn) {
                    const linkHTML = `
                        <div class="mega-inner-row-link-title">
                            <a class="btn-with-arrow-45 btn-with-arrow-45--dark"
                                href="${linkHref}"
                                target="_self">
                                <span class="text">${linkText}</span>
                                <span class="arrow">
                                    <img class="default"
                                        src="/wp-content/themes/f5-studio/src/assets/icons/arrow-45-gradient-dark.svg"
                                        alt="arrow" />
                                    <img class="gradient"
                                        src="/wp-content/themes/f5-studio/src/assets/icons/arrow-45-gradient.svg"
                                        alt="arrow" />
                                </span>
                            </a>
                        </div>`;

                    megaMenuColumn.insertAdjacentHTML("afterbegin", linkHTML);
                }
            }
        });
    }

    const slimSelectWrapper = document.querySelector('.page-header__btn-language .ss-main');

    if (slimSelectWrapper) {
        const toggleElement = slimSelectWrapper.querySelector('.ss-single-selected');
        slimSelectWrapper.addEventListener('mouseenter', function () {
            if (toggleElement) {
                slimSelectWrapper.querySelector('.ss-content').classList.add('ss-open');
                slimSelectWrapper.querySelector('.ss-single-selected').classList.add('ss-open-below');
            }
        });
        slimSelectWrapper.addEventListener('mouseleave', function () {
            if (toggleElement) {
                slimSelectWrapper.querySelector('.ss-content').classList.remove('ss-open');
                slimSelectWrapper.querySelector('.ss-single-selected').classList.remove('ss-open-below');
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.querySelector('.js-blur-overlay');
    const megaMenus = document.querySelectorAll('.mega-menu-megamenu');
    const desktopCloseButton = document.querySelector('.page-header__desktop-close');

    if (!overlay || !megaMenus.length) return;

    let hideTimer = null;

    const isMenuOpen = () => !!document.querySelector('.mega-menu-megamenu.mega-toggle-on');

    const updateOverlay = () => {
        if (isMenuOpen()) {
            overlay.classList.add('active');
            desktopCloseButton.classList.add('active');
            // if (window.lenis) window.lenis.stop();
        } else {
            overlay.classList.remove('active');
            desktopCloseButton.classList.remove('active');
            // if (window.lenis) window.lenis.start();
        }
    };

    const desktopMenuLinks = document.querySelectorAll('.mega-toggle-on > a');

    if (desktopCloseButton) {
        desktopCloseButton.addEventListener('click', () => {
            desktopMenuLinks.forEach(link => {
                link.dispatchEvent(new MouseEvent('mouseleave', {
                    bubbles: true
                }));

                link.click();
            });

            updateOverlay();
        });
    }

    const KILL_SCROLL = (e) => {
        if (isMenuOpen()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
        }
    };

    window.addEventListener('wheel', KILL_SCROLL, { passive: false, capture: true });
    
    window.addEventListener('keydown', (e) => {
        const keys = ['ArrowUp', 'ArrowDown', 'Space', 'PageUp', 'PageDown'];
        if (isMenuOpen() && keys.includes(e.code)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }, { capture: true });

    megaMenus.forEach(menu => {
        menu.addEventListener('mouseenter', () => {
            if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
            updateOverlay();
        });

        menu.addEventListener('mouseleave', () => {
            hideTimer = setTimeout(() => { hideTimer = null; updateOverlay(); }, 500);
        });
    });

    const observer = new MutationObserver(updateOverlay);
    megaMenus.forEach(menu => {
        observer.observe(menu, { attributes: true, attributeFilter: ['class'] });
    });

    updateOverlay();
});
